import React, { useContext, ReactNode } from "react";
import ReservationPageContext from "./reservationPageContext";

const SubPageLayout = ({
	title,
	children,
	extraClass="",
	backPage="summary"
}: {
	title: string;
	children: ReactNode;
	extraClass?: string;
	backPage?: string;
}) => {
	const pageContext = useContext(ReservationPageContext);
	const goBack = pageContext.setPage.bind(null, backPage);
	return (
		<div className={`wizard ${extraClass}`}>
			<div className="wizardHeader">
				<div className="back" onClick={goBack}></div>
				<div className="title">{title}</div>
			</div>
			{children}
		</div>
	);
};

export default SubPageLayout;
